/**
 * @generated SignedSource<<19f55c602b99ebcd1c6d68abf8d3fc15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type OrderEditMainPaymentsTableDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type OrderEditMainPaymentsTableDeleteMutation$data = {
  readonly deleteNode: string | null;
};
export type OrderEditMainPaymentsTableDeleteMutation = {
  response: OrderEditMainPaymentsTableDeleteMutation$data;
  variables: OrderEditMainPaymentsTableDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "deleteNode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrderEditMainPaymentsTableDeleteMutation",
    "selections": [
      (v3/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrderEditMainPaymentsTableDeleteMutation",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "deleteNode",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "10b5559fd78aa3ac7d43a730f6719cc2",
    "id": null,
    "metadata": {},
    "name": "OrderEditMainPaymentsTableDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation OrderEditMainPaymentsTableDeleteMutation(\n  $id: ID!\n) {\n  deleteNode(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "9b47c60280374792ed7a3ee2d2633753";

export default node;
